export default __webpack_public_path__ + "static/media/icon-dla wrazliwego ukladu pokarmowego.05231058.svg";